var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progressbar"},_vm._l((_vm.questions),function(question,index){return _c('div',{key:question.uid,staticClass:"progressbar-question",class:{
      'progressbar-answered':
        question.answer !== null && !_vm.isCurrent(question),
      'progressbar-current': _vm.isCurrent(question)
    },on:{"click":function($event){return _vm.questionSelected(index)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }